import { DataGrid } from "@mui/x-data-grid/DataGrid";
import React from "react";

interface DataTableProps {
	rows: any;
	columns: any;
	onRowClick?: (params: any) => void;
}

export const DataTable: React.FC<DataTableProps> = (props) => {
	return (
		<div
			style={{
				width: "100%",
					minHeight: props.rows.length > 0 ? "auto" : "200px",
					overflowX: "auto",
			}}
		>
			<DataGrid
				autoHeight
				rows={props.rows}
				columns={props.columns}
				onRowClick={props.onRowClick}
				initialState={{
					pagination: {
						paginationModel: { page: 0, pageSize: 10 },
					},
				}}
				pageSizeOptions={[10, 15, 20, 30]}
			/>
		</div>
	);
};
